export default {
  'Extract audio': 'Extract audio',
  'Mute': 'Mute',
  'Split video and audio': 'Split video and audio',
}